<template>
  <div id="rose-chart">
    <module-title title="今日支付方式占比" />
    <div id="paywayChart" style="width: 100%; height: 70%;"></div>

  </div>
</template>

<script>
import moduleTitle from '@/components/Common/ModuleTitle.vue';


export default {
  name: 'PayWay',
  components: {
    moduleTitle
  },
  props: {
    payWayData: {
      type: Array,
      default: () => [
        {
          value: 23, name: '微信支付', itemStyle: {
            color: '#14D85D'
          }
        },
        {
          value: 8, name: '储值支付', itemStyle: {
            color: '#FFA837'
          }
        },
        {
          value: 4, name: '其他支付', itemStyle: {
            color: '#F22E2E'
          }
        },

        {
          value: 65, name: '思迅pay 433,999.00', itemStyle: {
            color: '#0088F0'
          }
        },

      ],
    }
  },
  data() {
    return {
      chart: null, // 用于存储 ECharts 实例

      options: {
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            name: '支付方式占比',
            type: 'pie',
            radius: ['25%', '70%'],
            center: ['50%', '55%'],
            avoidLabelOverlap: true,
            startAngle: 180,
            label: {
              rich: {
                name: {
                  fontSize: 10,
                  color: '#ccc',
                  width: 80,
                  overflow: 'truncate',
                  ellipsis: '...'
                },
                value: {
                  fontSize: 12,
                  fontWeight: 'bold',
                  color: 'white'
                },
              },
              formatter: function (params) {
                let name = params.name;
                if (name.length > 8) {
                  name = name.substring(0, 8) + '...';
                }
                return `{name|${name}}\n\n{value|${params.value}}`;
              },
              alignTo: 'labelLine',
              color: 'white',
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true,
              length: 10,
              length2: 10
            },
            data: this.payWayData
          }
        ]
      }
    }
  },
  mounted() {
    // 初始化 ECharts 实例
    this.chart = this.$echarts.init(document.getElementById('paywayChart')); // 如果你选择了全局引入
    // 或者
    // this.chart = echarts.init(document.getElementById('myChart')); // 如果你选择了按需引入

    // 使用配置项和数据显示图表
    this.chart.setOption(this.options);
  },
  watch: {
    payWayData: {
      handler(newValue) {
        if (!newValue) return
        if (newValue.length == 0) return
        let payData = [];
        newValue.forEach((item) => {
          payData.push({
            value: item.PayAmt, name: item.PayName,
          },)
        })
        console.log('payData', payData)
        // 当 payWayData 发生变化时，更新图表数据
        this.options.series[0].data = payData;
        this.chart.setOption(this.options);
      },
      deep: true // 深度监听
    }
  },

  methods: {
    handleResize() {
      // 调用 chart 的 resize 方法
      if (this.chart) {
        this.chart.resize();
      }
    }
  },
}
</script>

<style lang="less" scoped>
#rose-chart {
  width: 100%;
  height: 100%;
  background: rgba(24, 50, 148, 0.30);
  border: 1px solid;
  border-image: linear-gradient(156deg, rgba(255, 255, 255, 0.30) 8%, rgba(255, 255, 255, 0.00) 91%) 1 1;
  border-radius: 8px;

}
</style>
